<div class="flex justify-center items-center px-4 py-2.5 border-t border-gray-200 bg-gradient-to-r from-white via-white to-white h-auto h-10">

  <div class="flex flex-row justify-start items-center">

    <!-- Icon -->
    <mat-icon class="text-yellow-500 mr-2">flash_on</mat-icon>

    <!-- Powered By -->
    <span class="text-sm">{{'Poweredby'|translate}}<a class="font-bold" target="_blank" [href]="FULLE_URL">Fülle</a></span>

  </div>

</div>
